import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { FormArray, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-pricing-options-step',
  templateUrl: './pricing-options-step.component.html',
  styleUrls: ['../event-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PricingOptionsStepComponent {
  eventForm: InputSignal<UntypedFormGroup> = input.required();
  isEventLocked: InputSignal<boolean> = input.required();

  addProductEvent: OutputEmitterRef<void> = output();
  removeProductEvent: OutputEmitterRef<number> = output();

  get products() {
    return this.eventForm().get('products') as FormArray;
  }

  addProduct() {
    this.addProductEvent.emit();
  }

  removeProduct(index: number) {
    this.removeProductEvent.emit(index);
  }
}
